// extracted by mini-css-extract-plugin
export var aiStarIcon = "_at-4";
export var closeButton = "_at-6";
export var dismissButton = "_at-3";
export var editImageWithAiContainer = "_at-8";
export var imageUploadWrapper = "_at-7";
export var misspelledWord = "_at-5";
export var spellCheckContainer = "_at-2";
export var spin = "_at-1";
export var spinning = "_at-0";